import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [error, setError] = useState('');

  const handleSuccess = async (credentialResponse) => {
    setError('');
    try {
      await login(credentialResponse.credential);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoSection}>
          <h1 style={styles.logo}>
            <span style={styles.logoAccent}>e</span>mew
          </h1>
          <p style={styles.subtitle}>AIVA</p>
        </div>

        <div style={styles.divider} />

        <p style={styles.instructions}>Sign in with your emew Google account</p>

        <div style={styles.buttonWrapper}>
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => setError('Google sign-in failed. Please try again.')}
            theme="outline"
            size="large"
            width="300"
            text="signin_with"
            hosted_domain="emew.com"
            useOneTap={false}
          />
        </div>

        {error && <p style={styles.error}>{error}</p>}

        <p style={styles.footer}>Only @emew.com accounts with approved access can sign in.</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #142D55 0%, #3E68B2 100%)',
  },
  card: {
    background: '#fff',
    borderRadius: '16px',
    padding: '48px 40px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    textAlign: 'center',
    maxWidth: '420px',
    width: '100%',
    margin: '0 20px',
  },
  logoSection: { marginBottom: '8px' },
  logo: { fontSize: '2.5rem', fontWeight: 700, color: '#142D55', margin: 0, letterSpacing: '-0.02em' },
  logoAccent: { color: '#38D430' },
  subtitle: { fontSize: '1.1rem', color: '#718096', margin: '4px 0 0', fontWeight: 600, letterSpacing: '0.05em' },
  divider: { height: '1px', background: '#E2E8F0', margin: '24px 0' },
  instructions: { fontSize: '0.95rem', color: '#1A202C', marginBottom: '24px', fontWeight: 500 },
  buttonWrapper: { display: 'flex', justifyContent: 'center', marginBottom: '16px' },
  error: { color: '#E53E3E', fontSize: '0.875rem', margin: '12px 0 0', fontWeight: 500 },
  footer: { fontSize: '0.8rem', color: '#A0AEC0', marginTop: '20px' },
};